import React, { useEffect, useState, useRef } from "react";
import apiDefinitions from "../../../api/apiDefinitions";
import { jwtDecode } from "jwt-decode";
import { useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Select, { MultiValue } from "react-select";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

const UpdateMyLead = () => {
  const hasDataLoaded = useRef(false);
  const route = all_routes;
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [nic, setNic] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [contactMethod, setContactMethod] = useState<number[]>([]);
  const [sourceOfInquiry, setSourceOfInquiry] = useState("");
  const [preferredDegree, setPreferredDegree] = useState("");
  const [selectedCourses, setSelectedCourses] = useState<number[]>([]);

  const [leadStatus, setLeadStatus] = useState("");
  const [priority, setPriority] = useState("");
  const [followUpDate, setFollowUpDate] = useState("");
  const [note, setNote] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const { id } = useParams<{ id: string }>(); // Extract the ID from the URL
  const [leadId, setLeadId] = useState<number | null>(null); // State to store the lead ID
  const [assignedBy, setAssignedBy] = useState("");
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [isCampaignInValid, setIsCampaignInValid] = useState(false);

  useEffect(() => {
    if (id) {
      console.log("Lead ID:", id);
      setLeadId(Number(id)); // Set the lead ID
    }
  }, [id]);

  const [isFullNameInvalid, setIsFullNameInvalid] = useState(false);
  const [isContactNumberInvalid, setIsContactNumberInvalid] = useState(false);
  const [isEmailAddressInvalid, setIsEmailAddressInvalid] = useState(false);
  const [isContactMethodInvalid, setIsContactMethodInvalid] = useState(false);
  const [isSourceOfInquiryInvalid, setIsSourceOfInquiryInvalid] =
    useState(false);
  const [isPreferredDegreeInvalid, setIsPreferredDegreeInvalid] =
    useState(false);
  const [isPreferredCourseInvalid, setIsPreferredCourseInvalid] =
    useState(false);
  const [isLeadStatusInvalid, setIsLeadStatusInvalid] = useState(false);
  const [isPriorityInvalid, setIsPriorityInvalid] = useState(false);
  const [isFollowUpDateInvalid, setIsFollowUpDateInvalid] = useState(false);
  const [isNicInvalid, setIsNicInvalid] = useState(false);
  const [isRepresentativeNameInvalid, setIsRepresentativeNameInvalid] =
    useState(false);
  const [isAssignedByInvalid, setIsAssignedByInvalid] = useState(false);
  const [campaignList, setCampaignList] = useState<Category[]>([]);

  const [coursesList, setCoursesList] = useState<any[]>([]);
  const [coursesCategoryList, setCoursesCategoryList] = useState<any[]>([]);
  const [prorityLevelStatus, setPriorityLevelStatus] = useState(false);
  const [employeeList, setEmployeeList] = useState<any[]>([]);

  const [socialMediaType, setSocialMediaType] = useState("2");
  const [isSocialMediaTypeInvalid, setIsSocialMediaTypeInvalid] =
    useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [sourceOfInquiryName, setSourceOfInquiryName] = useState("");
  const [leadStatusName, setLeadStatusName] = useState("");
  const [leadStatusId, setLeadStatusId] = useState("");
  const [initialLeadStatus, setInitialLeadStatus] = useState("");
  const [assignedTo, setAssignedTo] = useState("");
  const [firstTime, setFirstTime] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [approvalStatusCode, setApprovalStatusCode] = useState<number | null>(
    null
  );

  const [whatsapp, setWhatsapp] = useState("");
  const [isWhatsappInvalid, setIsWhatsappInvalid] = useState(false);
  const [isGuardian, setIsGuardian] = useState(false);

  interface FormValues {
    fullName: string;
    contactNumber: string;
    emailAddress: string;
    contactMethod: string;
    sourceOfInquiry: string;
    preferredDegree: string;
    preferredCourse: string;
    leadStatus: string;
    priority: string;
    followUpDate: string;
    note: string;
    nic: string;
    representativeName: string;
    socialMediaType: string;
    sourceOfInquiryName: string;
    leadStatusName: string;
    leadStatusId: string;
    assignedTo: string;
  }

  interface FormValidation {
    isFullNameInvalid: boolean;
    isContactNumberInvalid: boolean;
    isEmailAddressInvalid: boolean;
    isContactMethodInvalid: boolean;
    isSourceOfInquiryInvalid: boolean;
    isPreferredDegreeInvalid: boolean;
    isPreferredCourseInvalid: boolean;
    isLeadStatusInvalid: boolean;
    isPriorityInvalid: boolean;
    isFollowUpDateInvalid: boolean;
    isNicInvalid: boolean;
    isRepresentativeNameInvalid: boolean;
    isAssignedByInvalid: boolean;
    prorityLevelStatus: boolean;
    isSocialMediaTypeInvalid: boolean;
  }

  interface Option {
    value: number;
    label: string;
  }

  interface Category {
    id: number;
    name: string;
  }

  interface DecodedToken {
    exp: number; // Expiration time in seconds
    [key: string]: any; // Other properties if needed
  }

  const handleContactMethodChange = (method: number) => {
    setContactMethod(
      (prev) =>
        prev.includes(method)
          ? prev.filter((item) => item !== method) // Remove if exists
          : [...prev, method] // Add if not exists
    );
  };

  const validateNic = (value: string) => {
    if (value.length === 12) {
      setIsNicInvalid(false);
    } else if (
      value.length === 10 &&
      (value.endsWith("v") || value.endsWith("V"))
    ) {
      setIsNicInvalid(false);
    } else {
      setIsNicInvalid(true);
    }
  };

  const handleNicChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setNic(value);
    validateNic(value);
  };

  const options: Option[] = coursesList.map((course) => ({
    value: course.course_id,
    label: course.course_name,
  }));

  const handleBack = (event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    navigate(route.myLeads);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      console.log("Decoded Token", decodedToken);

      setEmployeeId(decodedToken.serial_number);
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLButtonElement>) => {
    event.preventDefault();

    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (fullName === "") {
      setIsFullNameInvalid(true);
      isValid = false;
    } else {
      setIsFullNameInvalid(false);
    }

    if (contactNumber === "" && whatsapp === "") {
      isValid = false;
      setIsContactNumberInvalid(true);
      setIsWhatsappInvalid(true);
    } else {
      if (contactNumber !== "" && contactNumber.length !== 10) {
        isValid = false;
        setIsContactNumberInvalid(true);
      } else {
        setIsContactNumberInvalid(false);
      }
      if (whatsapp !== "" && whatsapp.length !== 10) {
        isValid = false;
        setIsWhatsappInvalid(true);
      } else {
        setIsWhatsappInvalid(false);
      }
    }

    if (emailAddress && !emailRegex.test(emailAddress)) {
      isValid = false;
      setIsEmailAddressInvalid(true);
    } else {
      setIsEmailAddressInvalid(false);
    }

    // if (contactMethod.length === 0) {
    //   setIsContactMethodInvalid(true);
    //   toast.error("Please select a contact method");
    //   isValid = false;
    // } else {
    //   setIsContactMethodInvalid(false);
    // }

    if (sourceOfInquiry === "" || sourceOfInquiry === "Select an option") {
      setIsSourceOfInquiryInvalid(true);
      isValid = false;
    } else {
      setIsSourceOfInquiryInvalid(false);
    }

    if (preferredDegree === "" || preferredDegree === "Select an option") {
      setIsPreferredDegreeInvalid(true);
      isValid = false;
    } else {
      setIsPreferredDegreeInvalid(false);
    }

    if (nic === "") {
      setIsNicInvalid(true);
      isValid = false;
    } else {
      setIsNicInvalid(false);
    }

    if (preferredDegree !== "" && selectedCourses.length === 0) {
      setIsPreferredCourseInvalid(true);
      toast.error("Please select a preferred course");
      isValid = false;
    } else {
      setIsPreferredCourseInvalid(false);
    }

    if (sourceOfInquiry === "2" && representativeName === "") {
      setIsRepresentativeNameInvalid(true);
      console.log("Representative Name is invalid");
      isValid = false;
    } else {
      setIsRepresentativeNameInvalid(false);
      console.log(representativeName, "Representative Name is valid");
    }

    if (sourceOfInquiry === "5" && selectedCampaign === "") {
      setIsCampaignInValid(true);
      isValid = false;
    } else {
      setIsCampaignInValid(false);
    }

    // if (preferredCourse.length === 0) {
    //   setIsPreferredCourseInvalid(true);
    //   isValid = false;
    // } else {
    //   setIsPreferredCourseInvalid(false);
    // }

    if (leadStatus === "" || leadStatus === "Select an option") {
      setIsLeadStatusInvalid(true);
      isValid = false;
    } else {
      setIsLeadStatusInvalid(false);
    }

    if (priority === "" || priority === "Select an option") {
      setIsPriorityInvalid(true);
      isValid = false;
    } else {
      setIsPriorityInvalid(false);
    }

    // if (followUpDate === "") {
    //   setIsFollowUpDateInvalid(true);
    //   isValid = false;
    // } else {
    //   setIsFollowUpDateInvalid(false);
    // }

    if (leadStatus !== "5" && leadStatus !== "6" && leadStatus !== "8") {
      // Validate followUpDate only if leadStatus is not 6 or 8
      if (!followUpDate || followUpDate === "") {
        setIsFollowUpDateInvalid(true);
        isValid = false;
      } else {
        setIsFollowUpDateInvalid(false);
      }
    } else {
      // Reset the error state if followUpDate is not required
      setIsFollowUpDateInvalid(false);
    }

    if (assignedBy === "" || assignedBy === "Select an option") {
      setIsAssignedByInvalid(true);
      isValid = false;
    } else {
      setIsAssignedByInvalid(false);
    }

    if (assignedBy === assignedTo) {
      isValid = false;
      toast.error("Cannot Assign to the Same Employee");
    }

    if (parseInt(leadStatus) < parseInt(initialLeadStatus)) {
      toast.error("Cannot Select a Previous Lead Status");
      isValid = false;
    }

    if (isValid) {
      const payload = {
        fullname: fullName.toUpperCase(),
        contactNumber: contactNumber,
        email: emailAddress.toLowerCase(),
        // preferredContactMethod: contactMethod,
        sourceOfInquiry: {
          id: sourceOfInquiry,
        },
        courseCategoryId: preferredDegree,
        courseId: selectedCourses,
        leadStatus: {
          id: leadStatus,
        },
        leadPriorityLevelId: priority,
        assignedBy: assignedBy,
        followUpDate: followUpDate,
        note: note,
        nic: nic,
        social_media_type: socialMediaType,
        assignedTo: assignedTo,
        updatedBy: employeeId,
        campaign: {
          id: selectedCampaign,
        },
      };

      console.log("Form is valid", payload);

      Swal.fire({
        title: "Do You Want To Save The Changes?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Save",
        denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }

          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);

            console.log("currentTime", currentTime);
            console.log("Token", token);

            const loading = toast.loading("Saving Changes...");

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              // Token is valid, proceed with the API call
              apiDefinitions
                .updateLead(token, employeeId, leadId, payload)
                .then((response: any) => {
                  if (response.data.code === 200) {
                    setRefresh(true);
                    toast.dismiss(loading);
                    toast.success("Lead Details Updated Successfully");
                  } else {
                    toast.error("Failed to Update Lead");
                    toast.dismiss(loading);
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        } else {
          toast("Changes Were Not Saved", {
            icon: "⚠️",
          });
        }
      });
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getAllActiveCampaigns(token).then((response: any) => {
          console.log("Campaign Categories: ", response.data.data);
          setCampaignList(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    if (leadStatus === "5" || leadStatus === "6" || leadStatus === "8") {
      setFollowUpDate("null");
      console.log("Follow Up Date", followUpDate);
    }
  }, [leadStatus]);

  useEffect(() => {
    console.log("Selected Courses", followUpDate);
  }, [followUpDate]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (preferredDegree) {
        if (decodedToken.exp && decodedToken.exp > currentTime) {
          apiDefinitions
            .getCoursesByCategoryId(token, preferredDegree)
            .then((response: any) => {
              console.log("Response", response.data.data);
              setCoursesList(response.data.data);
            });
        } else {
          console.log("Session expired. Please log in again.");
          navigate(route.login);
        }
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, [preferredDegree]);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getAllCoursesCategories(token).then((response: any) => {
          console.log("Course Categories: ", response.data.data);
          setCoursesCategoryList(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getMarketingEmployeeList(token).then((response: any) => {
          console.log("Course Categories: ", response.data.data);
          setEmployeeList(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    if (leadId) {
      try {
        const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp && decodedToken.exp > currentTime) {
          apiDefinitions.getLeadById(token, leadId).then((response: any) => {
            const data = response.data.data;
            console.log("Lead Data By ID: ", data);

            setIsLoading(false);
            setFullName(data.fullname);
            setContactNumber(data.contactNumber);
            setEmailAddress(data.email);
            // setContactMethod(data.preferredContactMethod);
            setSourceOfInquiry(data.sourceOfInquiry.id);
            setPreferredDegree(data.courseCategoryId);
            setSelectedCourses(data.courseId);
            setLeadStatus(data.leadStatus.id);
            setPriority(data.leadPriorityLevelId);
            setFollowUpDate(
              response.data.data.followUpDate
                ? response.data.data.followUpDate.includes("T")
                  ? response.data.data.followUpDate.split("T")[0]
                  : response.data.data.followUpDate
                : null
            );
            setSelectedOption(data.sourceOfInquiry.id);
            setSelectedCampaign(data.campaign ? data.campaign.id : "");

            // setFollowUpDate(followUpDate);
            setLeadStatusName(data.leadStatus.status_name);
            setNote(data.note);
            setNic(data.nic);
            setAssignedBy(data.assignedBy);
            setSocialMediaType(data.social_media_type);
            setSourceOfInquiryName(data.sourceOfInquiry.source);
            setLeadStatusId(data.leadStatus.id);
            setInitialLeadStatus(data.leadStatus.id);
            setAssignedTo(data.assignedTo);
            setApprovalStatusCode(data.assignStatus[0]);
          });
        } else {
          console.log("Session expired. Please log in again.");
          navigate("/login");
        }
      } catch (error) {
        console.error("Invalid token or unable to decode", error);
      }
    }
  }, [leadId, navigate, refresh]);

  useEffect(() => {
    console.log("Approval Status Code: ", approvalStatusCode);
  }, [approvalStatusCode]);

  useEffect(() => {
    if (
      leadStatusName === "Enrolled" ||
      leadStatusName === "Disqualified" ||
      leadStatusName === "Lost" ||
      leadStatusId === "5" ||
      leadStatusId === "6" ||
      leadStatusId === "8"
    ) {
      setFollowUpDate("null");
    } else if (
      leadStatusId === "1" ||
      leadStatusId === "2" ||
      leadStatusId === "3" ||
      leadStatusId === "4" ||
      leadStatusId === "5" ||
      leadStatusId === "7"
    ) {
      const today = new Date();
      today.setDate(today.getDate() + 3);
      const followUpDate = today.toISOString().split("T")[0];
      setFollowUpDate(followUpDate);
      console.log("Follow Up Date", followUpDate);
    }
  }, [leadStatus]);

  useEffect(() => {
    console.log("Selected Lead Status", leadStatus);
  }, [leadStatus]);

  // useEffect(() => {
  //   if (sourceOfInquiryName === "Social Media") {
  //     setSelectedOption(4);
  //     setFirstTime(false);
  //     console.log("Social Media Selected");
  //   } else if (sourceOfInquiryName === "Representative") {
  //     console.log("Representative Selected");
  //     setSelectedOption(2);
  //     setFirstTime(false);
  //   } else {
  //     console.log("Direct Call Selected");
  //     setSelectedOption(null);
  //     setFirstTime(false);
  //   }
  // }, [sourceOfInquiry]);

  useEffect(() => {
    console.log("Selected Option", sourceOfInquiry);
  }, [sourceOfInquiry]);

  useEffect(() => {
    if (leadStatus === "1" || leadStatusName === "New") {
      setPriority("3");
      setPriorityLevelStatus(true);
      console.log("Priority Level 3");
    } else {
      setPriorityLevelStatus(false);
      console.log("Priority Level not 3");
    }
  }, [leadStatus]);

  const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const onlyLettersAndSpaces = /^[a-zA-Z\s]*$/;

    if (onlyLettersAndSpaces.test(input)) {
      setFullName(input); // Update the state only if the input contains valid characters
    }
  };

  const handleContactNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = e.target.value;
    const onlyNumbers = /^[0-9]*$/;

    if (onlyNumbers.test(input)) {
      setContactNumber(input); // Update the state only if the input contains valid numbers
    }
  };

  const handleSourceOfInquiryChange = (value: string) => {
    setSourceOfInquiry(value);

    // Reset or clear the fields for other source types
    if (value === "2") {
      // For "Representative" source
      setSelectedOption(2); // Show the Representative Name field
      setSocialMediaType("");
      setSelectedCampaign(""); // Clear the social media type field
    } else if (value === "4") {
      // For "Social Media" source
      setSelectedOption(4); // Show the Social Media Type field
      setRepresentativeName("");
      setSelectedCampaign(""); // Clear the representative name field
    } else if (value === "5") {
      setSelectedOption(5);
      setSocialMediaType(""); // Show the Campaign Name field
      setRepresentativeName("");
    } else {
      // For other sources like "Direct Call"
      setSelectedOption(null); // Hide both fields
      setSocialMediaType(""); // Clear the social media type field
      setRepresentativeName("");
      setSelectedCampaign(""); // Clear the representative name field
    }
  };

  useEffect(() => {
    console.log("Selected Source of Inquiry", selectedOption);
  }, [selectedOption]);

  // useEffect(() => {
  //   if (!hasDataLoaded) {
  //   setSocialMediaType("");
  //   setRepresentativeName("");
  //   }
  // }, [sourceOfInquiry]);

  const handleWhatsappNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = e.target.value;
    const onlyNumbers = /^[0-9]*$/;

    if (onlyNumbers.test(input)) {
      setWhatsapp(input);
      // Validate length
      if (input.length > 0 && input.length !== 10) {
        setIsWhatsappInvalid(true);
      } else {
        setIsWhatsappInvalid(false);
      }
    }
  };

  return (
    <>
      {isloading === true ? (
        <div className="card-body">
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-10">
                      <h4 className="page-title">Update Quick Leads</h4>
                    </div>
                    <div className="col-2 text-end">
                      <button className="btn btn-primary" onClick={handleBack}>
                        <i
                          className="feather-arrow-left"
                          style={{ fontSize: "17px", marginRight: "5px" }}
                        />{" "}
                        Back to list
                      </button>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="card">
                    <div className="card-header card-buttons">
                      <h5 className="card-title">1) Basic Information</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm">
                          <form className="needs-validation" noValidate>
                            <div className="form-row row">
                              <div className="col-md-4 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustom01"
                                >
                                  Full Name
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      isFullNameInvalid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustom01"
                                    placeholder="Full Name"
                                    value={fullName}
                                    onChange={(e) => handleFullNameChange(e)}
                                    style={{ textTransform: "uppercase" }}
                                    required
                                  />
                                  {isFullNameInvalid && (
                                    <div className="invalid-feedback">
                                      Please enter a valid full name (letters
                                      and spaces only).
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-4 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustom02"
                                >
                                  Contact Number
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      isContactNumberInvalid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustom02"
                                    placeholder="Contact Number"
                                    value={contactNumber}
                                    onChange={(e) =>
                                      handleContactNumberChange(e)
                                    }
                                    required
                                  />
                                  {isContactNumberInvalid && (
                                    <div className="invalid-feedback">
                                      Please enter a valid contact number
                                      (numbers only).
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-4 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustom03"
                                >
                                  Whatsapp Number
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      isWhatsappInvalid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustom03"
                                    placeholder="Whatsapp Number"
                                    value={whatsapp}
                                    onChange={(e) =>
                                      handleWhatsappNumberChange(e)
                                    }
                                    required
                                  />
                                  {isWhatsappInvalid && (
                                    <div className="invalid-feedback">
                                      Please enter a valid whatsApp number.
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-4 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustom01"
                                >
                                  NIC
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      isNicInvalid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustom01"
                                    placeholder="NIC"
                                    value={nic}
                                    onChange={handleNicChange}
                                    required
                                    disabled={true}
                                  />
                                  {isNicInvalid && (
                                    <div className="invalid-feedback">
                                      Please enter a valid NIC.
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-4 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomUsername"
                                >
                                  Email Address
                                </label>
                                <div className="input-group">
                                  <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                  >
                                    {" "}
                                    @{" "}
                                  </span>
                                  <input
                                    type="text"
                                    className={`form-control ${
                                      isEmailAddressInvalid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustomUsername"
                                    placeholder="Email Address"
                                    aria-describedby="inputGroupPrepend"
                                    value={emailAddress}
                                    onChange={(e) =>
                                      setEmailAddress(e.target.value)
                                    }
                                    style={{ textTransform: "lowercase" }}
                                    required
                                  />
                                  {isEmailAddressInvalid && (
                                    <div className="invalid-feedback">
                                      Please enter a valid email address.
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* <div className="col-md-4 mb-3">
                              <label
                                className="form-label"
                                htmlFor="validationCustomContactMethod"
                              >
                                Contact Method
                              </label>
                              <select
                                className={`form-select ${
                                  isContactMethodInvalid ? "is-invalid" : ""
                                }`}
                                id="validationCustomContactMethod"
                                value={contactMethod}
                                onChange={(e) =>
                                  setContactMethod(e.target.value)
                                }
                                required
                              >
                           <option value="">Select an option</option>
                                <option value="1">Call</option>
                                <option value="2">Email</option>
                                <option value="3">Text</option>
                              </select>
                              {isContactMethodInvalid && (
                                <div className="invalid-feedback">
                                  Please select a contact method.
                                </div>
                              )}
                            </div> */}
                              {/* <div className="col-xxl-4 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div>
                                  <label
                                    className="form-label"
                                    htmlFor="validationCustomContactMethod"
                                  >
                                    Contact Method
                                  </label>
                                  <div className="d-sm-flex align-items-center justify-content-between">
                                    <div className="form-check form-check-md d-flex align-items-center">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="1"
                                        id="checkbox-call"
                                        checked={contactMethod.includes(1)}
                                        onChange={() =>
                                          handleContactMethodChange(1)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="checkbox-call"
                                      >
                                        Call
                                      </label>
                                    </div>
                                    <div className="form-check form-check-md d-flex align-items-center">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="2"
                                        id="checkbox-email"
                                        checked={contactMethod.includes(2)}
                                        onChange={() =>
                                          handleContactMethodChange(2)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="checkbox-email"
                                      >
                                        Email
                                      </label>
                                    </div>
                                    <div className="form-check form-check-md d-flex align-items-center">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="3"
                                        id="checkbox-text"
                                        checked={contactMethod.includes(3)}
                                        onChange={() =>
                                          handleContactMethodChange(3)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="checkbox-text"
                                      >
                                        Text
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              <div className="card-header card-buttons">
                                <h5 className="card-title">2) Lead Source</h5>
                              </div>
                              <div className="col-md-4 mb-3 mt-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomContactMethod"
                                >
                                  Source of Inquiry
                                </label>
                                <select
                                  className={`form-select ${
                                    isSourceOfInquiryInvalid ? "is-invalid" : ""
                                  }`}
                                  id="validationCustomContactMethod"
                                  value={sourceOfInquiry}
                                  onChange={(e) =>
                                    handleSourceOfInquiryChange(e.target.value)
                                  }
                                  required
                                >
                                  <option value="">Select an option</option>
                                  <option value="1">Direct Call</option>
                                  <option value="2">Representative</option>
                                  <option value="3">Website</option>
                                  <option value="4">Social Media</option>
                                  <option value="5">Campaigns</option>
                                </select>
                                {isSourceOfInquiryInvalid && (
                                  <div className="invalid-feedback">
                                    Please select a source of inquiry.
                                  </div>
                                )}
                              </div>

                              {/* Conditional rendering for Representative's Name */}
                              {selectedOption === 2 && (
                                <div className="col-md-4 mb-3 mt-3">
                                  <label
                                    className="form-label"
                                    htmlFor="representativeName"
                                  >
                                    Representative's Name
                                  </label>
                                  <select
                                    className={`form-select ${
                                      isRepresentativeNameInvalid
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    id="representativeName"
                                    value={representativeName}
                                    onChange={(e) =>
                                      setRepresentativeName(e.target.value)
                                    }
                                    required
                                  >
                                    <option value="">Select an option</option>
                                    <option value="1">Representative 01</option>
                                    <option value="2">Representative 02</option>
                                    <option value="3">Representative 03</option>
                                    <option value="4">Representative 04</option>
                                  </select>
                                  {isRepresentativeNameInvalid && (
                                    <div className="invalid-feedback">
                                      Please select a representative's name.
                                    </div>
                                  )}
                                </div>
                              )}

                              {Number(sourceOfInquiry) === 5 && (
                                <div className="col-md-4 mb-3 mt-3">
                                  <label
                                    className="form-label"
                                    htmlFor="validationCustomContactMethod"
                                  >
                                    Campaign Name
                                  </label>
                                  <select
                                    className={`form-select ${
                                      isCampaignInValid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustomContactMethod"
                                    value={selectedCampaign}
                                    onChange={(e) =>
                                      setSelectedCampaign(e.target.value)
                                    }
                                    required
                                  >
                                    <option value="">Select an option</option>
                                    {campaignList.map((campaign: Category) => (
                                      <option
                                        key={campaign.id}
                                        value={campaign.id}
                                      >
                                        {campaign.name}
                                      </option>
                                    ))}
                                  </select>
                                  {isCampaignInValid && (
                                    <div className="invalid-feedback">
                                      Please select a social media type.
                                    </div>
                                  )}
                                </div>
                              )}

                              {/* Conditional rendering for Social Media Type */}
                              {selectedOption === 4 && (
                                <div className="col-md-4 mb-3 mt-3">
                                  <label
                                    className="form-label"
                                    htmlFor="socialMediaType"
                                  >
                                    Social Media Type
                                  </label>
                                  <select
                                    className={`form-select ${
                                      isSocialMediaTypeInvalid
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    id="socialMediaType"
                                    value={socialMediaType || ""}
                                    onChange={(e) =>
                                      setSocialMediaType(e.target.value)
                                    }
                                    required
                                  >
                                    <option value="">Select an option</option>
                                    <option value="1">Facebook</option>
                                    <option value="2">Instagram</option>
                                    <option value="3">LinkedIn</option>
                                    <option value="4">Tik Tok</option>
                                  </select>
                                  {isSocialMediaTypeInvalid && (
                                    <div className="invalid-feedback">
                                      Please select a social media type.
                                    </div>
                                  )}
                                </div>
                              )}

                              <div className="card-header card-buttons">
                                <h5 className="card-title">
                                  3) Academic Interest
                                </h5>
                              </div>
                              <div className="col-md-4 mb-3 mt-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomContactMethod"
                                >
                                  Preferred Degree
                                </label>
                                <select
                                  className={`form-select ${
                                    isPreferredDegreeInvalid ? "is-invalid" : ""
                                  }`}
                                  id="validationCustomContactMethod"
                                  value={preferredDegree}
                                  onChange={(e) =>
                                    setPreferredDegree(e.target.value)
                                  }
                                  required
                                >
                                  <option value="">Select an option</option>
                                  {coursesCategoryList.map((courseCategory) => (
                                    <option
                                      key={courseCategory.course_category_id}
                                      value={courseCategory.course_category_id}
                                    >
                                      {courseCategory.category_name}
                                    </option>
                                  ))}
                                </select>
                                {isPreferredDegreeInvalid && (
                                  <div className="invalid-feedback">
                                    Please select a preferred degree.
                                  </div>
                                )}
                              </div>
                              <div className="col-md-12 mb-3 mt-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomContactMethod"
                                >
                                  Preferred Course
                                </label>

                                <Select
                                  classNamePrefix="react-select"
                                  className="js-example-placeholder-multiple select2 js-states"
                                  isMulti={true}
                                  placeholder="Select"
                                  options={options}
                                  value={options.filter((option) =>
                                    selectedCourses.includes(option.value)
                                  )}
                                  onChange={(selectedOptions) => {
                                    const courseValues = selectedOptions.map(
                                      (option) => option.value
                                    );
                                    setSelectedCourses(courseValues);
                                  }}
                                />

                                {isPreferredCourseInvalid && (
                                  <div className="invalid-feedback">
                                    Please select a preferred course.
                                  </div>
                                )}
                              </div>
                              <div className="card-header card-buttons">
                                <h5 className="card-title">
                                  4) Status and Priority
                                </h5>
                              </div>
                              <div className="col-md-4 mb-3 mt-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomContactMethod"
                                >
                                  Lead Status
                                </label>
                                <select
                                  className={`form-select ${
                                    isLeadStatusInvalid ? "is-invalid" : ""
                                  }`}
                                  id="validationCustomContactMethod"
                                  value={leadStatus}
                                  onChange={(e) => {
                                    setLeadStatus(e.target.value);
                                    setLeadStatusId(e.target.value);
                                  }}
                                  required
                                >
                                  <option value="">Select an option</option>
                                  <option value="1">New</option>
                                  <option value="2">Contacted</option>
                                  <option value="3">Interested</option>
                                  <option value="4">
                                    Application in Progress
                                  </option>
                                  <option value="5">Enrolled</option>
                                  <option value="6">Disqualified</option>
                                  {/* <option value="7">Follow-Up Needed</option> */}
                                  <option value="8">Lost</option>
                                  <option value="9">Not Responded</option>
                                  <option value="10">Next Intake</option>
                                </select>
                                {isLeadStatusInvalid && (
                                  <div className="invalid-feedback">
                                    Please select a lead status.
                                  </div>
                                )}
                              </div>
                              <div className="col-md-4 mb-3 mt-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomContactMethod"
                                >
                                  Lead Priority Level
                                </label>
                                <select
                                  className={`form-select ${
                                    isPriorityInvalid ? "is-invalid" : ""
                                  }`}
                                  id="validationCustomContactMethod"
                                  value={priority}
                                  onChange={(e) => setPriority(e.target.value)}
                                  disabled={prorityLevelStatus}
                                  required
                                >
                                  <option value="">Select an option</option>
                                  <option value="1">Low </option>
                                  <option value="2">Medium</option>
                                  <option value="3">High </option>
                                </select>
                                {isPriorityInvalid && (
                                  <div className="invalid-feedback">
                                    Please select a priority level.
                                  </div>
                                )}
                              </div>
                              <div className="card-header card-buttons">
                                <h5 className="card-title">
                                  5) Follow Up Details
                                </h5>
                              </div>

                              {leadStatusId === "5" ||
                              leadStatusId === "6" ||
                              leadStatusId === "8" ||
                              leadStatusName === "Enrolled" ||
                              leadStatusName === "Lost" ||
                              leadStatusName === "Disqualified" ? null : (
                                <div className="col-md-4 mt-3">
                                  <label
                                    className="form-label"
                                    htmlFor="validationCustomFollowUpDate"
                                  >
                                    Follow Up Date
                                  </label>
                                  <input
                                    type="date"
                                    className={`form-control ${
                                      isFollowUpDateInvalid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustomFollowUpDate"
                                    value={followUpDate}
                                    min={new Date().toISOString().split("T")[0]}
                                    onChange={(e) =>
                                      setFollowUpDate(e.target.value)
                                    }
                                    required
                                  />
                                  {isFollowUpDateInvalid && (
                                    <div className="invalid-feedback">
                                      Please select a follow-up date.
                                    </div>
                                  )}
                                </div>
                              )}

                              <div className="col-md-8 mb-3 mt-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomContactMethod"
                                >
                                  Additional Note
                                </label>
                                <textarea
                                  rows={1}
                                  cols={5}
                                  className="form-control"
                                  placeholder="Enter text here"
                                  defaultValue={""}
                                  onChange={(e) => setNote(e.target.value)}
                                  value={note}
                                />
                              </div>
                              <div className="card-header card-buttons">
                                <h5 className="card-title">
                                  6) Lead Assign Details
                                </h5>
                              </div>
                              <div className="col-md-4 mb-3 mt-3">
                                <label
                                  className="form-label"
                                  htmlFor="validationCustomContactMethod"
                                >
                                  Assigned By
                                </label>
                                <select
                                  className={`form-select ${
                                    isAssignedByInvalid ? "is-invalid" : ""
                                  }`}
                                  id="validationCustomContactMethod"
                                  value={assignedBy}
                                  onChange={(e) =>
                                    setAssignedBy(e.target.value)
                                  }
                                  required
                                  disabled
                                >
                                  <option value="">Select an option</option>
                                  {employeeList.map((employeee) => (
                                    <option
                                      key={employeee.serial_number}
                                      value={employeee.serial_number}
                                    >
                                      {employeee.name_in_full}
                                    </option>
                                  ))}
                                </select>
                                {isAssignedByInvalid && (
                                  <div className="invalid-feedback">
                                    Please select a name.
                                  </div>
                                )}
                              </div>

                              {leadStatusId === "6" ||
                              leadStatusId === "8" ||
                              leadStatusName === "Lost" ||
                              leadStatusName === "Disqualified" ? null : (
                                <div className="col-md-4 mb-3 mt-3">
                                  <label
                                    className="form-label"
                                    htmlFor="validationCustomContactMethod"
                                  >
                                    Assigned To
                                  </label>
                                  <select
                                    className={`form-select ${
                                      isAssignedByInvalid ? "is-invalid" : ""
                                    }`}
                                    id="validationCustomContactMethod"
                                    value={assignedTo}
                                    onChange={(e) =>
                                      setAssignedTo(e.target.value)
                                    }
                                    required
                                    disabled={approvalStatusCode === 2}
                                  >
                                    <option value="">Select an option</option>
                                    {employeeList.map((employeee) => (
                                      <option
                                        key={employeee.serial_number}
                                        value={employeee.serial_number}
                                      >
                                        {employeee.name_in_full}
                                      </option>
                                    ))}
                                  </select>
                                  {isAssignedByInvalid && (
                                    <div className="invalid-feedback">
                                      Please select a name.
                                    </div>
                                  )}
                                </div>
                              )}

                              <div className="col-md-3 mt-3"></div>

                              <div className="col-md-1 mt-5">
                                <button
                                  className="btn btn-primary"
                                  onClick={handleSubmit}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateMyLead;
